import { createStore, combineReducers, applyMiddleware } from 'redux';
import { routerReducer } from 'react-router-redux';
import thunk from 'redux-thunk';
import app from './ducks/app';
import cards from './ducks/cards';
import operations from './ducks/operations';
import tanks from './ducks/tanks';
import devices from './ducks/devices';
import limits from './ducks/limits';
import users from './ducks/users';
import roles from './ducks/roles';
import orderHistory from './ducks/order_history'
import userCards from './ducks/user_cards'

let dispatch;
let getState;

const configureStore = (initialState) => {
    const reducers = combineReducers({
        routing: routerReducer,
        app,
        cards,
        userCards,
        operations,
        tanks,
        devices,
        limits,
        users,
        roles,
        orderHistory
    });

    const middlewares = [thunk];

    if (process.env.NODE_ENV === `development`) {
        const { logger } = require(`redux-logger`);

        middlewares.push(logger);
    }

    const store = createStore(reducers, initialState, applyMiddleware(...middlewares));
    dispatch = store.dispatch;
    getState = store.getState;
    return store;
}

export {configureStore, dispatch, getState};